import React, { useMemo } from "react";
import LeftBar from "../Project/LeftBar";
import DefaultErrorBoundary from "../DefaultErrorBoundary";
import classNames from "classnames";
import { useProjectStore } from "../../stores/projectStore";
import { useSudowriteStore } from "../../stores/sudowriteStore";
import { useAppStore } from "../../stores/appStore";
import styled from "styled-components/macro";
import IconButton from "../IconButton";

const StyledLeftBarOuterContainer = styled.div`
`;

export function LeftBarContainer({ propWidth, setCollapsed }) {
  const contents = useProjectStore((state) => state.contents);
  const project = useProjectStore((state) => state.project);
  const leftRef = useProjectStore((state) => state.leftRef);
  const columnWidths = useProjectStore((state) => state.columnWidths);
  const subscription = useSudowriteStore((state) => state.subscription);
  const isSW2 = useAppStore((state) => state.isSW2);
  const isMac = useAppStore((state) => state.isMac);

  const collapsed = columnWidths.left.collapsed;
  const compact = columnWidths.left.current < 275;
  const separateCollapseRow = columnWidths.left.current <= 191;
  const importBlocksLeftBar = project?.importStep && project.importStep !== "CANCELLED";
  const width = propWidth && isSW2 ? propWidth : columnWidths.left.initial;
  // Avoid a new style object each render when width is unchanged (styled-components + WDUR).
  const outerStyle = useMemo(() => ({ width }), [width]);

  return (
    contents && (
      <>
        {collapsed && !isSW2 && (
          <div className="collapsed-left-bar">
            <IconButton
              onClick={() => {
                if (importBlocksLeftBar) return;
                setCollapsed(false);
              }}
              src="/assets/right-arrow.svg"
              ariaLabel={importBlocksLeftBar ? "Expand Left Bar (unavailable while importing)" : "Expand Left Bar"}
              hoverTipText={importBlocksLeftBar ? "Unavailable while importing" : "Expand Left Bar"}
            />
          </div>
        )}
        {(isSW2 || !collapsed) && (
          <StyledLeftBarOuterContainer
            className={classNames({ "left-bar": true, sw2: isSW2, collapsed, "styled-scrollbars": !isMac })}
            style={outerStyle}
            ref={leftRef}
          >
            <DefaultErrorBoundary>
              <LeftBar
                showCanvas={true}
                showStoryEngine={subscription.hasAccessToStoryEngine}
                showChat={subscription.hasAccessToChat}
                setCollapsed={setCollapsed}
                isSW2={isSW2} // TODO: Remove this when 2.0 is default
                compact={compact}
                separateCollapseRow={separateCollapseRow}
                collapsed={collapsed}

              />
            </DefaultErrorBoundary>
          </StyledLeftBarOuterContainer>
        )}
      </>
    )
  );
}
